import { Check } from "lucide-react";

const TEAM_IMG =
  "https://images.pexels.com/photos/7108269/pexels-photo-7108269.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const values = [
  "Senior talent only — no farm-out, no interns on your account",
  "Transparent pricing — fixed-fee or weekly, never padded hours",
  "Business outcomes over aesthetic preferences",
  "Documentation & handover are included, not add-ons",
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="bg-[color:var(--fis-bg-alt)]"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-24 md:py-32 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="font-mono-label mb-4">§ 03 — About</div>
          <h2 className="font-display text-5xl md:text-6xl">
            A studio built
            <br />
            for the frontline.
          </h2>
          <p className="mt-6 text-[color:var(--fis-ink-soft)] leading-relaxed max-w-md">
            FIS is a cross-disciplinary studio of engineers, designers,
            recruiters and AI researchers. We work with founders, operators and
            enterprise teams who need a single partner across their digital,
            talent and AI stack.
          </p>

          <ul className="mt-8 space-y-3">
            {values.map((v) => (
              <li key={v} className="flex gap-3 items-start">
                <Check className="w-4 h-4 mt-1 text-[color:var(--fis-accent)]" />
                <span>{v}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-7 md:col-start-6">
          <div className="aspect-[4/3] overflow-hidden">
            <img
              src={TEAM_IMG}
              alt="FIS team"
              className="w-full h-full object-cover"
              data-testid="about-team-image"
            />
          </div>
          <div className="grid grid-cols-2 gap-6 mt-6 text-sm">
            <div className="border-t fis-hairline pt-4">
              <div className="font-mono-label">Headquarters</div>
              <div className="mt-1">C-27, EFC, 2nd Floor, Trapezoid IT Park, Sector 62, Noida, UP 201301</div>
            </div>
            <div className="border-t fis-hairline pt-4">
              <div className="font-mono-label">Founded</div>
              <div className="mt-1">2020 — shipping ever since.</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
